import React from "react";
import { Badge } from "@mantine/core";

export const EpBadge = ({ text }: { text: string }) => {
  return (
    <Badge
      color="gray"
      variant="light"
      size="xs"
      sx={(theme) => ({
        fontFamily: '"Consolas", Menlo, monospace',
        fontWeight: 400,
        backgroundColor: "rgba(84,180,152,0.10)",
        color: "#54B498",
      })}
    >
      {text}
    </Badge>
  );
};
